import type {
  TopicVideoApplySearchCriteriaAction,
  TopicVideoClearSearchCriteriaAction,
} from "domains/videos/actionTypes";
import { TopicVideoActionTypes } from "domains/videos/actionTypes";

export const applyVideoSearchCriteria = (
  payload?: TopicVideoApplySearchCriteriaAction["payload"],
  meta?: TopicVideoApplySearchCriteriaAction["meta"],
): TopicVideoApplySearchCriteriaAction => ({
  type: TopicVideoActionTypes.APPLY_SEARCH_CRITERIA,
  payload,
  meta,
});

export const clearVideoSearchCriteria = (): TopicVideoClearSearchCriteriaAction => ({
  type: TopicVideoActionTypes.CLEAR_SEARCH_CRITERIA,
});
